import { render, staticRenderFns } from "./AlteraAcompanhamentoPublicacoes.vue?vue&type=template&id=3b1aa462&scoped=true"
import script from "./AlteraAcompanhamentoPublicacoes.vue?vue&type=script&lang=js"
export * from "./AlteraAcompanhamentoPublicacoes.vue?vue&type=script&lang=js"
import style0 from "./AlteraAcompanhamentoPublicacoes.vue?vue&type=style&index=0&id=3b1aa462&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1aa462",
  null
  
)

export default component.exports